module.exports = __webpack_public_path__ + "img/book.dbedf72e.svg";